import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Chip,
} from "@mui/material";
import { getTypeColor, getSeverityColor } from "./utils";

export default function ViewTemplateDialog({ open, onClose, template }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Template Details</DialogTitle>
      <DialogContent>
        {template && (
          <Box sx={{ pt: 2 }}>
            <Typography variant="subtitle2" color="text.secondary">
              Name
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }} p={0} m={0}>
              {template.name}
            </Typography>

            <Typography variant="subtitle2" color="text.secondary">
              Category
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }} p={0} m={0}>
              {template.category || "general"}
            </Typography>

            <Typography variant="subtitle2" color="text.secondary">
              Type & Severity
            </Typography>
            <Box sx={{ mb: 2 }}>
              <Chip
                label={template.type}
                color={getTypeColor(template.type)}
                size="small"
                sx={{ mr: 1 }}
              />
              <Chip
                label={template.severity || "medium"}
                color={getSeverityColor(template.severity)}
                size="small"
              />
            </Box>

            {template.variables && template.variables.length > 0 && (
              <>
                <Typography variant="subtitle2" color="text.secondary">
                  Variables
                </Typography>
                <Box sx={{ mb: 2 }}>
                  {template.variables.map((variable, idx) => (
                    <Chip
                      key={idx}
                      label={variable}
                      size="small"
                      sx={{ mr: 0.5, mb: 0.5 }}
                    />
                  ))}
                </Box>
              </>
            )}

            <Typography variant="subtitle2" color="text.secondary">
              Title
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }} p={0} m={0}>
              {template.title}
            </Typography>

            <Typography variant="subtitle2" color="text.secondary">
              Message
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }} p={0} m={0}>
              {template.message}
            </Typography>

            <Typography variant="subtitle2" color="text.secondary">
              Status
            </Typography>
            <Chip
              label={template.isActive ? "Active" : "Inactive"}
              color={template.isActive ? "success" : "default"}
              size="small"
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
